import { render } from "./PuxDate.pug?vue&type=template&id=889cc4e2&lang=pug"
import script from "./PuxDate.js?vue&type=script&lang=js"
export * from "./PuxDate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__